export default "__VITE_ASSET__CjIiILMz__"